import { Col, Form, Row } from "antd";
import QuestionOptionContent from "./QuestionOptionContent";

export default function QuestionContent(props) {
	const {
		namePath = [],
		question = null,
		description = null,
		type = null,
		required = false,
		max_checkbox = 0,
		add_another = false,
		form_question_options = [],
	} = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;

	return (
		<Row>
			<Col
				xs={24}
				sm={24}
				md={24}
				lg={24}
				xl={24}
				style={
					Array.isArray(namePath) && namePath.length > 0
						? { paddingLeft: 20 }
						: {}
				}
			>
				<QuestionOptionContent
					question={question}
					description={description}
					namePath={newNamePath}
					type={type}
					required={required}
					max_checkbox={max_checkbox}
					add_another={add_another}
					form_question_options={
						form_question_options.length > 0 ? form_question_options : []
					}
				/>
			</Col>
			<Form.Item dependencies={[newNamePath]} noStyle>
				{({ getFieldValue }) => {
					const selectedOption = getFieldValue(newNamePath);
					let form_question_option = form_question_options.find(
						(option) => option.option === selectedOption,
					);

					if (form_question_option?.sub_option_type) {
						let newQuestion = form_question_option.question_option || null;
						let newType = form_question_option.sub_option_type || null;
						let newRequired = form_question_option.required ? true : false;
						let newMaxCheckbox = form_question_option.max_checkbox || 0;
						let newEscapeQuestions =
							form_question_option.escape_questions || [];
						let newFormQuestionOptions =
							form_question_option.form_question_options || [];

						return (
							<Col
								xs={24}
								sm={24}
								md={24}
								lg={24}
								xl={24}
								style={{
									paddingLeft: 20,
								}}
							>
								<QuestionContent
									namePath={`${newNamePath}_qo_${form_question_option.id}`}
									question={newQuestion}
									type={newType}
									required={newRequired}
									max_checkbox={newMaxCheckbox}
									escape_questions={newEscapeQuestions}
									form_question_options={newFormQuestionOptions}
								/>
							</Col>
						);
					}

					return null;
				}}
			</Form.Item>
		</Row>
	);
}
